(() => {
  const initCarousels = (scope) => {
    scope.querySelectorAll('[data-vv2-carousel]').forEach((carousel) => {
      if (carousel.dataset.vv2Bound === 'true') return;
      const track = carousel.querySelector('[data-vv2-track]');
      const prev = carousel.querySelector('[data-vv2-prev]');
      const next = carousel.querySelector('[data-vv2-next]');
      const controls = carousel.querySelector('[data-vv2-controls]');
      if (!track || !prev || !next || !controls) return;
      carousel.dataset.vv2Bound = 'true';
      const isVertical = () => carousel.dataset.vv2Axis === 'vertical' && window.matchMedia('(min-width: 851px)').matches;
      const update = () => {
        const vertical = isVertical();
        const max = Math.max(0, vertical ? track.scrollHeight - track.clientHeight : track.scrollWidth - track.clientWidth);
        const position = vertical ? track.scrollTop : track.scrollLeft;
        controls.hidden = max < 2;
        prev.disabled = position < 2;
        next.disabled = position > max - 2;
      };
      const move = (direction) => {
        const vertical = isVertical();
        const child = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const step = child ? child.getBoundingClientRect()[vertical ? 'height' : 'width'] + gap : track[vertical ? 'clientHeight' : 'clientWidth'];
        track.scrollBy(vertical ? { top: direction * step, behavior: 'smooth' } : { left: direction * step, behavior: 'smooth' });
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    });
  };
  const initProducts = (scope) => {
    scope.querySelectorAll('[data-vv2-product]').forEach((detail) => {
      if (detail.dataset.vv2Bound === 'true') return;
      detail.dataset.vv2Bound = 'true';
      const main = detail.querySelector('.vv2-detail__main-media img');
      const thumbs = [...detail.querySelectorAll('.vv2-detail__thumb')];
      const showImage = (url, alt, activeThumb = null) => {
        if (!main || !url) return;
        main.src = url;
        main.removeAttribute('srcset');
        main.alt = alt || '';
        thumbs.forEach((item) => {
          const active = item === activeThumb || (!activeThumb && item.dataset.vv2ImageUrl === url);
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      };
      detail.querySelectorAll('[data-vv2-image-url]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          showImage(thumb.dataset.vv2ImageUrl, thumb.dataset.vv2ImageAlt, thumb);
        });
      });
      const select = detail.querySelector('[data-vv2-variant-select]');
      const price = detail.querySelector('[data-vv2-variant-price]');
      const button = detail.querySelector('[data-vv2-add-button]');
      const stock = detail.querySelector('[data-vq-stock-note]');
      if (select && price && button) {
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          if (!option) return;
          price.textContent = option.dataset.price || '';
          if (option.dataset.comparePrice) {
            const old = document.createElement('s');
            old.textContent = option.dataset.comparePrice;
            price.append(old);
          }
          button.disabled = option.dataset.available !== 'true';
          if (stock) stock.textContent = button.disabled ? 'Sold out' : 'Ready to ship';
          const label = button.querySelector('[data-vv2-button-label]');
          if (label) label.textContent = button.disabled ? button.dataset.soldoutLabel : button.dataset.addLabel;
          if (option.dataset.imageUrl) showImage(option.dataset.imageUrl, option.dataset.imageAlt);
        });
      }
      const quantity = detail.querySelector('[name="quantity"]');
      const minus = detail.querySelector('[data-vv2-qty-minus]');
      const plus = detail.querySelector('[data-vv2-qty-plus]');
      if (quantity && minus && plus) {
        const updateQuantity = (normalize = false) => {
          const value = Number.parseInt(quantity.value, 10);
          const next = Number.isFinite(value) && value >= 1 ? value : 1;
          if (normalize) quantity.value = String(next);
          minus.disabled = next <= 1;
        };
        minus.addEventListener('click', () => {
          quantity.value = String(Math.max(1, (Number.parseInt(quantity.value, 10) || 1) - 1));
          updateQuantity(true);
        });
        plus.addEventListener('click', () => {
          quantity.value = String((Number.parseInt(quantity.value, 10) || 0) + 1);
          updateQuantity(true);
        });
        quantity.addEventListener('input', () => updateQuantity());
        quantity.addEventListener('change', () => updateQuantity(true));
        updateQuantity(true);
      }
      const policyDialog = detail.querySelector('[data-vv2-policy-dialog]');
      if (policyDialog) {
        const policyTitle = policyDialog.querySelector('[data-vv2-policy-title]');
        const policyContent = [...policyDialog.querySelectorAll('[data-vv2-policy-content]')];
        detail.querySelectorAll('[data-vv2-open-policy]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const kind = trigger.dataset.vv2OpenPolicy;
            policyContent.forEach((content) => { content.hidden = content.dataset.vv2PolicyContent !== kind; });
            if (policyTitle) policyTitle.textContent = kind === 'shipping' ? 'Shipping policy' : 'Return & refund policy';
            if (!policyDialog.open) policyDialog.showModal();
          });
        });
        policyDialog.querySelector('[data-vv2-close-policy]')?.addEventListener('click', () => policyDialog.close());
        policyDialog.addEventListener('click', (event) => {
          if (event.target === policyDialog) policyDialog.close();
        });
      }
    });
  };
  const initProductCardImages = (root) => {
    if (root.dataset.vv2CardImagesBound === 'true') return;
    root.dataset.vv2CardImagesBound = 'true';
    const loadHoverImage = (target) => {
      const card = target.closest('[data-product-card]');
      const template = card?.querySelector('template[data-vv2-hover-image]');
      if (!template) return;
      template.replaceWith(template.content.cloneNode(true));
    };
    root.addEventListener('pointerover', (event) => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) loadHoverImage(event.target);
    }, { passive: true });
    root.addEventListener('focusin', (event) => loadHoverImage(event.target));
  };
  const initQuickCart = (root) => {
    const drawer = root.querySelector('[data-vv2-quick-cart]');
    if (!drawer || drawer.dataset.vv2Bound === 'true') return;
    drawer.dataset.vv2Bound = 'true';
    const panel = drawer.querySelector('.vv2-quick-cart__panel');
    const items = drawer.querySelector('[data-vv2-cart-items]');
    const message = drawer.querySelector('[data-vv2-cart-message]');
    const subtotal = drawer.querySelector('[data-vv2-cart-subtotal]');
    const drawerCount = drawer.querySelector('[data-vv2-drawer-count]');
    const localeRoot = window.Shopify?.routes?.root || root.dataset.vv2CartRoot || '/';
    const cartRoot = localeRoot.endsWith('/') ? localeRoot : `${localeRoot}/`;
    let returnFocus = null;
    let adding = false;

    const showMessage = (value, isError = false) => {
      message.textContent = value || '';
      message.hidden = !value;
      message.classList.toggle('is-error', isError);
    };
    const money = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency || 'USD'
        }).format((cents || 0) / 100);
      } catch {
        return `${((cents || 0) / 100).toFixed(2)} ${currency || ''}`.trim();
      }
    };
    const updateCounts = (count) => {
      root.querySelectorAll('[data-vv2-cart-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count < 1;
      });
      root.querySelectorAll('[data-vv2-mobile-cart-count]').forEach((badge) => {
        badge.textContent = `(${count})`;
        badge.hidden = count < 1;
      });
      drawerCount.textContent = `(${count})`;
    };
    const renderCart = (cart) => {
      items.replaceChildren();
      updateCounts(cart.item_count || 0);
      subtotal.textContent = money(cart.total_price, cart.currency);
      if (!cart.items?.length) {
        const empty = document.createElement('p');
        empty.className = 'vv2-quick-cart__empty';
        empty.textContent = 'Your bag is empty. Explore the archive and find your next piece.';
        items.append(empty);
        return;
      }
      cart.items.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'vv2-quick-cart__item';
        const imageLink = document.createElement('a');
        imageLink.className = 'vv2-quick-cart__item-image';
        const itemUrl = new URL(item.url || cartRoot, window.location.origin);
        imageLink.href = itemUrl.origin === window.location.origin ? itemUrl.href : cartRoot;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.product_title || item.title || '';
          image.loading = 'lazy';
          imageLink.append(image);
        }
        const info = document.createElement('div');
        info.className = 'vv2-quick-cart__item-info';
        const title = document.createElement('a');
        title.href = imageLink.href;
        title.textContent = item.product_title || item.title || 'Product';
        info.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          const variant = document.createElement('p');
          variant.textContent = item.variant_title;
          info.append(variant);
        }
        Object.entries(item.properties || {}).forEach(([key, value]) => {
          if (key.startsWith('_') || !value) return;
          const property = document.createElement('p');
          property.textContent = `${key}: ${value}`;
          info.append(property);
        });
        const line = document.createElement('strong');
        line.textContent = `${item.quantity} × ${money(item.final_price ?? item.price, cart.currency)}`;
        info.append(line);
        row.append(imageLink, info);
        items.append(row);
      });
    };
    const refreshCart = async () => {
      const response = await fetch(`${cartRoot}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Could not load your bag. Please use View Cart.');
      renderCart(await response.json());
    };
    const openCart = (trigger = document.activeElement) => {
      returnFocus = trigger;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      panel.focus();
      refreshCart().catch(() => showMessage('Could not load your bag. Please use View Cart.', true));
    };
    const closeCart = () => {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      showMessage('');
      if (returnFocus?.isConnected) returnFocus.focus();
    };
    root.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-vv2-open-cart]');
      if (opener && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        showMessage('');
        openCart(opener);
      }
      if (event.target.closest('[data-vv2-close-cart]')) closeCart();
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeCart();
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href],button:not([disabled])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    root.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!form.closest('[data-vv2-product]') || !event.submitter?.matches('[data-vv2-add-button]')) return;
      event.preventDefault();
      if (adding) return;
      adding = true;
      const addButton = event.submitter;
      const label = addButton.querySelector('[data-vv2-button-label]');
      const previousLabel = label?.textContent;
      addButton.disabled = true;
      if (label) label.textContent = 'Adding…';
      try {
        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this product.');
        const quantity = form.querySelector('[name="quantity"]');
        if (quantity) {
          quantity.value = '1';
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        showMessage('Added to your bag. Keep shopping or continue to checkout.');
        openCart(addButton);
      } catch (error) {
        showMessage(error.message || 'Could not add this product. Please try again.', true);
        openCart(addButton);
      } finally {
        adding = false;
        const selected = form.querySelector('[data-vv2-variant-select]')?.selectedOptions[0];
        addButton.disabled = selected ? selected.dataset.available !== 'true' : false;
        if (label) label.textContent = previousLabel;
      }
    });
  };
  const initBrowseTabs = (scope) => {
    scope.querySelectorAll('[data-vv2-browse]').forEach((browse) => {
      if (browse.dataset.vv2BrowseBound === 'true' || browse.hasAttribute('data-vv2-editor') || window.Shopify?.designMode) return;
      browse.dataset.vv2BrowseBound = 'true';
      let panel = browse.querySelector('[data-vv2-browse-panel]');
      const navigationRoot = browse.closest('[data-verik-v2]') || browse;
      let controller = null;
      const updateTabs = (url) => {
        const currentPath = new URL(url, window.location.href).pathname;
        navigationRoot.querySelectorAll('[data-vv2-collection-nav] [data-vv2-browse-tab]').forEach((tab) => {
          const active = new URL(tab.href).pathname === currentPath;
          tab.classList.toggle('is-active', active);
          if (active) tab.setAttribute('aria-current', 'page');
          else tab.removeAttribute('aria-current');
        });
      };
      const loadPanel = async (url, push) => {
        if (controller) controller.abort();
        const activeController = new AbortController();
        controller = activeController;
        panel.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(url, { signal: activeController.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Browse request failed: ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextPanel = html.querySelector('[data-vv2-browse-panel]');
          if (!nextPanel) throw new Error('Browse panel missing');
          if (controller !== activeController) return;
          const imported = document.importNode(nextPanel, true);
          panel.replaceWith(imported);
          panel = imported;
          if (push) history.pushState({ verikBrowse: true }, '', url);
          document.title = html.title;
          updateTabs(url);
          navigationRoot.querySelector('[data-vv2-scroll]')?.scrollTo({ top: 0, behavior: 'instant' });
          window.dispatchEvent(new Event('resize'));
        } catch (error) {
          if (error.name !== 'AbortError') window.location.assign(url);
        } finally {
          if (controller === activeController) panel.removeAttribute('aria-busy');
        }
      };
      navigationRoot.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-vv2-browse-tab]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target) return;
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin) return;
        event.preventDefault();
        if (url.href !== window.location.href) loadPanel(url.href, true);
      });
      window.addEventListener('popstate', () => {
        if (browse.isConnected) loadPanel(window.location.href, false);
      });
    });
  };
  const initFooterGroups = (scope) => {
    scope.querySelectorAll('[data-vv2-footer]').forEach((footer) => {
      if (footer.dataset.vv2FooterBound === 'true') return;
      footer.dataset.vv2FooterBound = 'true';
      const frame = footer.closest('.vv2-home-footer') || footer;
      let compact = null;
      const sync = () => {
        const nextCompact = frame.clientWidth <= 780;
        if (nextCompact === compact) return;
        compact = nextCompact;
        footer.querySelectorAll('[data-vv2-footer-group]').forEach((group) => {
          group.open = !compact || Boolean(group.querySelector('[data-vv2-footer-feedback]'));
        });
      };
      sync();
      new ResizeObserver(sync).observe(frame);
    });
  };
  const initFinder = (root) => {
    const finder = root.querySelector('.vv2-finder');
    const toggle = finder?.querySelector('[data-vv2-search-toggle]');
    const input = finder?.querySelector('input[name="q"]');
    if (!finder || !toggle || !input) return;
    const setExpanded = (expanded) => {
      finder.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', expanded ? 'Close search' : 'Open search');
      if (expanded) input.focus();
    };
    toggle.addEventListener('click', () => setExpanded(!finder.classList.contains('is-expanded')));
    finder.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && finder.classList.contains('is-expanded')) {
        setExpanded(false);
        toggle.focus();
      }
    });
    document.addEventListener('pointerdown', (event) => {
      if (finder.classList.contains('is-expanded') && !finder.contains(event.target)) setExpanded(false);
    });
  };
  const roots = document.querySelectorAll('[data-verik-v2]');
  for (const root of roots) {
    const scroll = root.querySelector('[data-vv2-scroll]');
    const bar = root.querySelector('[data-vv2-scrollbar]');
    const thumb = root.querySelector('[data-vv2-thumb]');
    if (!scroll || !bar || !thumb) continue;
    const updateBar = () => {
      const range = Math.max(0, scroll.scrollHeight - scroll.clientHeight);
      const ratio = scroll.scrollHeight ? scroll.clientHeight / scroll.scrollHeight : 1;
      const railHeight = bar.clientHeight;
      const thumbHeight = Math.max(30, Math.min(railHeight, railHeight * ratio));
      const top = range ? (scroll.scrollTop / range) * (railHeight - thumbHeight) : 0;
      thumb.style.height = `${thumbHeight}px`;
      thumb.style.top = `${top}px`;
      bar.setAttribute('aria-valuenow', String(Math.round(range ? scroll.scrollTop / range * 100 : 0)));
    };
    scroll.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    const observer = new ResizeObserver(updateBar);
    observer.observe(scroll);
    observer.observe(scroll.firstElementChild);
    requestAnimationFrame(updateBar);
    let dragging = false;
    const seek = (clientY) => {
      const rect = bar.getBoundingClientRect();
      const range = Math.max(0, scroll.scrollHeight - scroll.clientHeight);
      const fraction = Math.max(0, Math.min(1, (clientY - rect.top) / rect.height));
      scroll.scrollTop = fraction * range;
    };
    bar.addEventListener('pointerdown', (event) => { dragging = true; bar.setPointerCapture(event.pointerId); seek(event.clientY); });
    bar.addEventListener('pointermove', (event) => { if (dragging) seek(event.clientY); });
    bar.addEventListener('pointerup', () => { dragging = false; });
    bar.addEventListener('pointercancel', () => { dragging = false; });
    bar.addEventListener('keydown', (event) => {
      const step = scroll.clientHeight * 0.8;
      if (event.key === 'ArrowDown') scroll.scrollBy({ top: step / 4, behavior: 'smooth' });
      else if (event.key === 'ArrowUp') scroll.scrollBy({ top: -step / 4, behavior: 'smooth' });
      else if (event.key === 'PageDown') scroll.scrollBy({ top: step, behavior: 'smooth' });
      else if (event.key === 'PageUp') scroll.scrollBy({ top: -step, behavior: 'smooth' });
      else if (event.key === 'Home') scroll.scrollTo({ top: 0, behavior: 'smooth' });
      else if (event.key === 'End') scroll.scrollTo({ top: scroll.scrollHeight, behavior: 'smooth' });
      else return;
      event.preventDefault();
    });
    initCarousels(root);
    initProducts(root);
    initProductCardImages(root);
    initQuickCart(root);
    initFinder(root);
    initBrowseTabs(root);
    initFooterGroups(root);
    document.addEventListener('shopify:section:load', (event) => {
      if (!root.contains(event.target)) return;
      initCarousels(event.target);
      initProducts(event.target);
      initBrowseTabs(event.target);
      initFooterGroups(event.target);
      requestAnimationFrame(updateBar);
    });
    document.addEventListener('shopify:block:select', (event) => {
      if (!root.contains(event.target)) return;
      const track = event.target.closest('[data-vv2-track]');
      if (track) event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  }
})();
